exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register-container {\n  padding: 0px !important;\n}\n.register-attention {\n  color: red;\n  font-size: 1rem;\n}\n.register-locale {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.register-submit {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.register-newsletter-info {\n  font-size: 1rem;\n}", ""]);

// exports
